import React, { useState } from 'react';
import PricesMassage from './MassageUL-component';
import PricesBeauty from './BeautyUL-component';
import PricesMicropigmentation from './MicropigmentationUL-component';
import PricesBabysitter from './BabysitterUL-component';
import { SignupForm } from '../Form/Form-section';
import { Tabs, Tab } from 'react-bootstrap';
import prices_PageData from '../../mock/prices_Page.json';
import prices_PageData_studio from '../../mock/prices_studio.json';
import prices_BabysitterData from '../../mock/prices_babysitter.json';

const {
  Price_List_massage,
  Price_List_Micropigmentation,
  Price_List_Beauty,
  Price_List_MakeUp_Waxing,
  Price_List_Yoga,
} = prices_PageData;
const {
  Price_List_massage_studio,
  Price_List_Micropigmentation_studio,
  Price_List_Beauty_studio,
  Price_List_MakeUp_Waxing_studio,
  Price_List_Warts_studio,
  Warts_Note_studio,
} = prices_PageData_studio;
const { Price_List_Babysitter } = prices_BabysitterData;

const homeTabs = [
  {
    key: 'massage',
    title: 'Massage',
    prices: <PricesMassage priceListMassage={Price_List_massage} />,
    treatments: Price_List_massage,
  },
  {
    key: 'beauty',
    title: 'Beauty',
    prices: <PricesBeauty priceListBeauty={Price_List_Beauty} />,
    treatments: Price_List_Beauty,
  },
  {
    key: 'micropigmentation',
    title: 'Micropigmentation',
    prices: <PricesMicropigmentation priceListMicropigmentation={Price_List_Micropigmentation} />,
    treatments: Price_List_Micropigmentation,
  },
  {
    key: 'makeup-waxing',
    title: 'Make Up & Waxing',
    prices: <PricesBeauty priceListBeauty={Price_List_MakeUp_Waxing} />,
    treatments: Price_List_MakeUp_Waxing,
  },
  {
    key: 'yoga',
    title: 'Yoga',
    prices: <PricesBeauty priceListBeauty={Price_List_Yoga} />,
    treatments: Price_List_Yoga,
  },
];

const studioTabs = [
  {
    key: 'massage',
    title: 'Massage',
    prices: <PricesMassage priceListMassage={Price_List_massage_studio} />,
    treatments: Price_List_massage_studio,
  },
  {
    key: 'beauty',
    title: 'Beauty',
    prices: <PricesBeauty priceListBeauty={Price_List_Beauty_studio} />,
    treatments: Price_List_Beauty_studio,
  },
  {
    key: 'micropigmentation',
    title: 'Micropigmentation',
    prices: (
      <PricesMicropigmentation priceListMicropigmentation={Price_List_Micropigmentation_studio} />
    ),
    treatments: Price_List_Micropigmentation_studio,
  },
  {
    key: 'makeup-waxing',
    title: 'Make Up & Waxing',
    prices: <PricesBeauty priceListBeauty={Price_List_MakeUp_Waxing_studio} />,
    treatments: Price_List_MakeUp_Waxing_studio,
  },
  {
    key: 'warts',
    title: 'Extraction/Cauterization of Warts',
    prices: (
      <>
        <PricesBeauty priceListBeauty={Price_List_Warts_studio} />
        <p className="price-list-note">
          <em>{Warts_Note_studio}</em>
        </p>
      </>
    ),
    treatments: Price_List_Warts_studio,
  },
];

const PricesTabs = (props) => {
  const { type, entrance } = props;
  const tabs = type === 'studio' ? studioTabs : homeTabs;
  const [key, setKey] = useState(
    tabs.some((tab) => tab.key === entrance) ? entrance : tabs[0].key
  );

  if (type === 'babysitter') {
    return (
      <>
        <PricesBabysitter priceListBabysitter={Price_List_Babysitter} />
        <SignupForm showLocation={true} showTreatment={false} showEndDate={true} defaultTreatment="Babysitter" />
      </>
    );
  }

  return (
    <>
      <h5 style={{ textAlign: 'left' }}>*Choose section and fill up form request</h5>
      <Tabs id="controlled-tab" activeKey={key} onSelect={(k) => setKey(k)}>
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            tabClassName="price-list-section-title"
            eventKey={tab.key}
            title={tab.title}
          >
            {key === tab.key ? (
              <>
                {tab.prices}
                <SignupForm showLocation={type !== 'studio'} treatments={tab.treatments} />
              </>
            ) : null}
          </Tab>
        ))}
      </Tabs>
    </>
  );
};

export default PricesTabs;
